import React, { Component } from 'react';
import api from '../../../../services/api';

// Components
import AuthenticationStep from './StepComponents/AuthenticationStep/AuthenticationStep';
import AddItemsStep from './StepComponents/SelectCategoriesStep/SelectCategoriesStep';
import UploadStep from './StepComponents/UploadStep/UploadStep';
import ProductDataStep from './StepComponents/ProductDataStep/ProductDataStep';
import ReviewInformationStep from './StepComponents/ReviewInformationStep/ReviewInformationStep';
import OnboardCompletedStep from './StepComponents/OnboardCompletedStep/OnboardCompletedStep';

import './Onboard.css';

class Onboard extends Component {

    constructor(props) {
        super(props);
        const startStep = 1;
        const totalSteps = 7;

        this.state = {
            step: startStep,
            startStep: startStep,
            totalSteps: totalSteps,
            progressBarStyle: {
                width: '10%'
            },
            collectedData: {},
            errorMessage: ''
        };

        //bind the state altering functions
        this.validateThenAddDataToState = this.validateThenAddDataToState.bind(this);
        this.beginOnboarding = this.beginOnboarding.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.completeOnboarding = this.completeOnboarding.bind(this);
    }

    validateThenAddDataToState(data) {
        // data is a dictionary:
        // it has 1 key, whichq is the name of the step
        // values to that 1 key are the values associated with the step
        // we append that to our overarching state
        const newData = this.state.collectedData;
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let vals = data[keys[i]];
            newData[keys[i]] = vals;
        }

        this.setState({
            collectedData: newData
        });
    }

    beginOnboarding(email) {
        let nextStep = this.state.step + 1;

        // Email has already been validated
        let collectedDataUpdate = this.state.collectedData;
        collectedDataUpdate.userEmail = email;

        this.setState({
            step: nextStep,
            collectedData: collectedDataUpdate
        });
    }

    nextStep(data) {
        // Where data is the information collected at by the particular step
        this.validateThenAddDataToState(data);

        if (this.state.step === this.state.totalSteps) {
            return;
        }

        let nextStep = this.state.step + 1;
        let progressBarStyleWidth = (nextStep / this.state.totalSteps) * 100 + '%';

        this.setState({
            step: nextStep,
            progressBarStyle: {
                width: progressBarStyleWidth
            }
        });
    }

    previousStep() {
        if (this.state.step === 1) {
            return;
        }

        let prevStep = this.state.step - 1;
        let progressBarStyleWidth = (prevStep / this.state.totalSteps) * 100 + '%';

        this.setState({
            step: prevStep,
            progressBarStyle: {
                width: progressBarStyleWidth
            }
        });
    }

    completeOnboarding(data) {
        api.submitCollectedUserData(data)
        .then((res) => {
            let response = res.data;

            if (response.success) {
                // Move to the completed step
                let nextStep = this.state.step + 1;
                this.setState({
                    step: nextStep,
                });
            } else {
                console.error(res);
                this.setState({
                    errorMessage: 'There was an error somewhere on our end, please contact us at contact@kylxx.co with details of your problem.'
                });
            }
        });
    }

    // We want to conditionally render the step that we're on
    render() {
        let CurrentStepComponent = null;
        const propsToPass = {
            collectedData: this.state.collectedData,
            previousStep: this.previousStep,
            nextStep: this.nextStep,
            beginOnboarding: this.beginOnboarding,
            completeOnboarding: this.completeOnboarding
        };

        switch (this.state.step) {
            case 1:
                CurrentStepComponent = <AuthenticationStep {...propsToPass} />;
                break;
            case 2:
                CurrentStepComponent = <AddItemsStep {...propsToPass} />;
                break;
            case 3:
                CurrentStepComponent = <UploadStep {...propsToPass} />;
                break;
            case 4:
                CurrentStepComponent = <ProductDataStep {...propsToPass} />;
                break;
            case 5:
                CurrentStepComponent = <ReviewInformationStep {...propsToPass} />;
                break;
            case 6:
                CurrentStepComponent = <OnboardCompletedStep {...propsToPass} />;
                break;
            default:
                CurrentStepComponent = null;
        }

        return (
            <div className="onboard">
                {/*<div className="progress-div">*/}
                    {/*<div className="progress-bar-wrap">*/}
                        {/*<div style={this.state.progressBarStyle} className="progress-bar">*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}

                <div className="current-step-component">
                    {CurrentStepComponent}
                    <p className={"review-form-error" + (this.state.errorMessage.length > 0 ? '' : ' review-hidden-error')}>
                        {this.state.errorMessage}
                    </p>
                </div>
            </div>
        );

    }
};


export default Onboard;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/Onboard.js